'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DevSpinner = function DevSpinner() {
  return null;
}; // eslint-disable-line

if (process.env.REACT_STATIC_ENV === 'development') {
  DevSpinner = function DevSpinner() {
    return _react2.default.createElement(
      'div',
      {
        className: 'react-static-loading',
        style: {
          display: 'block',
          width: '100%',
          textAlign: 'center',
          padding: '10px'
        }
      },
      _react2.default.createElement(
        'style',
        null,
        '\n        @keyframes react-static-loader {\n          0% {\n            transform: rotate(0deg)\n          }\n          100% {\n            transform: rotate(360deg)\n          }\n        }\n      '
      ),
      _react2.default.createElement(
        'svg',
        {
          style: {
            width: '50px',
            height: '50px'
          }
        },
        _react2.default.createElement('circle', {
          style: {
            transformOrigin: '50% 50% 0px',
            animation: 'react-static-loader 1s infinite',
            r: 20,
            stroke: 'rgba(0,0,0,0.4)',
            strokeWidth: 4,
            cx: 25,
            cy: 25,
            strokeDasharray: 10.4,
            strokeLinecap: 'round',
            fill: 'transparent'
          }
        })
      )
    );
  };
}

exports.default = DevSpinner;


//////////////////
// WEBPACK FOOTER
// ../lib/client/components/DevSpinner.js
// module id = 18
// module chunks = 5